import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeatReservationItemComponent } from './seat-reservation-item.component';
import { AmountFormatModule, DateFormatModule, StaticMsgModule } from '@lib/pipes';
import { MilesFormatModule } from '@common/pipes/miles-format/miles-format.module';

@NgModule({
  declarations: [SeatReservationItemComponent],
  imports: [CommonModule, StaticMsgModule, AmountFormatModule, DateFormatModule, MilesFormatModule],
  exports: [SeatReservationItemComponent],
})
export class SeatReservationItemModule {}
